import React, { useEffect, useState } from 'react';
import { CircularProgress, Stack } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import MeterForm from '../components/MeterForm';
import { useGetMeterHandler } from '../dataHandlers/getMeterHandler';
import { useMutateMeterHandler } from '../dataHandlers/mutateMeterHandler';

export default function MeterEditPage() {
  const navigate = useNavigate();
  const { id } = useParams();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { meter, isLoading: isLoadingData } = useGetMeterHandler(id);
  const { onSubmit, error, isPending } = useMutateMeterHandler({
    onSuccess: () => navigate('/meters'),
  });

  useEffect(() => {
    if (!isPending && isSubmitting) setIsSubmitting(false);
  }, [isPending, isSubmitting]);

  if (isLoadingData || !meter) return <CircularProgress />;

  return (
    <Stack direction="column" sx={{ mt: '-2rem' }}>
      <MeterForm
        isEdit={true}
        onSubmit={(payload) => onSubmit({ meter_id: meter.meter_id, display_name: payload.display_name }, true)}
        onCancel={() => navigate('/meters')}
        initialData={meter}
        apiErrors={error}
        isLoading={isPending || isLoadingData || isSubmitting}
      />
    </Stack>
  );
}
